document.addEventListener("DOMContentLoaded", function() {
    attachDesktopEvents();
    attachMobileEvents();
});

const attachDesktopEvents = async () => {
    const desktopMenu = document.querySelector('.desktop-details');
    let menuButtons = desktopMenu.querySelectorAll('.accordion--menu button');
    let contentBlocks = desktopMenu.querySelectorAll('.accordion--content .content-block');
    for (let i = 0; i < menuButtons.length; i++) {
        const menuButton = menuButtons[i];
        menuButton.addEventListener('click', function() {
            // remove active from all menu buttons
            for (let j = 0; j < menuButtons.length; j++) {
                const menuButton = menuButtons[j];
                menuButton.classList.remove('active');
            }
            // remove active from all content blocks
            for (let j = 0; j < contentBlocks.length; j++) {
                const contentBlock = contentBlocks[j];
                contentBlock.classList.add('twcss-hidden');
            }
            // add active to the clicked menu button
            menuButton.classList.add('active');
            // add active to the corresponding content block
            let contentBlock = contentBlocks[i];
            contentBlock.classList.remove('twcss-hidden');
        });
    }
};

const attachMobileEvents = async () => {
    const mobileMenu = document.querySelector('.mobile-details');
    let menuButtons = mobileMenu.querySelectorAll('.accordion--menu');

    for (let i = 0; i < menuButtons.length; i++) {
        const menuButton = menuButtons[i];
        menuButton.addEventListener('click', function() {
            if (menuButton.classList.contains('active')) {
                menuButton.classList.remove('active');
            } else {
                // remove active from all menu buttons
                for (let j = 0; j < menuButtons.length; j++) {
                    const menuButton = menuButtons[j];
                    menuButton.classList.remove('active');
                }
                // add active to the clicked menu button
                menuButton.classList.add('active');
            }
        });

    }
};